<template>
  <div
    class="tips"
    :style="{
      fontSize: fontSize + 'px',
      padding: padding,
      marginBottom: marginBottom + 'px',
      marginTop: marginTop + 'px',
      marginLeft: marginLeft + 'px',
      marginRight: marginRight + 'px',
      background: background,
      border: `1px solid ${borderColor}`,
    }"
  >
    <img :src="icons[iconType]" alt="" :style="{ width: iconWidth + 'px', height: iconHeight + 'px' }" />
    <div :style="{ color: color, marginLeft: left + 'px' }">
      <slot>
        {{ text }}
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    iconType: {
      type: Number,
      default: 1,
    },
    borderColor: {
      type: String,
      default: 'transparent',
    },
    fontSize: {
      type: [String, Number],
      default: 14,
    },
    marginTop: {
      type: [String, Number],
      default: 0,
    },
    marginLeft: {
      type: [String, Number],
      default: 0,
    },
    marginBottom: {
      type: [String, Number],
      default: 0,
    },
    marginRight: {
      type: [String, Number],
      default: 0,
    },
    color: {
      type: String,
      default: '#31A8FF',
    },
    background: {
      type: String,
      default: '#EDF7FF',
    },
    iconWidth: {
      type: [String, Number],
      default: 14,
    },
    iconHeight: {
      type: [String, Number],
      default: 14,
    },
    left: {
      type: [String, Number],
      default: 12,
    },
    padding: {
      type: String,
      default: '10px 16px',
    },
  },
  data() {
    return {
      icons: {
        1: require('@/assets/image/MergeHouse.png'),
        2: require('@/assets/image/business-tips.png'),
        3: require('@/assets/image/business_tips.png'),
        4: require('@/assets/image/business-tips-warning.png'),
        5: require('@/assets/image/tips-warning.png'),
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.tips {
  display: flex;
  align-items: center;
  border-radius: 8px;
  line-height: 20px;
}
</style>
